
import React, { useEffect, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import Project from '../Project/Project';

const Projects = () => {
    const [projects, setProjects] = useState([]);
    useEffect(() => {
        fetch('projects.json')
            .then(res => res.json())
            .then(data => setProjects(data))
    }, []);

    return (
        <div id="portfolio" className="projects-container pb-4">
            <Container>
                <div className="text-center pt-5 pb-3">
                    <h1 className="">Projects</h1>
                    <hr className="dash" />
                </div>
                <Row>
                    {
                        projects.map(project => <Project
                            project={project}
                        ></Project>)
                    }
                </Row>
            </Container>
        </div>
    );
};

export default Projects;